<template>
  <div class="nuttrema-widget nuttrema-widget--notices-warning" v-show="showInitNotice || showNotice">
    <template>
      <h4 class="nuttrema-widget__sup_title">{{ $t('label.do_not_forget') }}</h4>
      <h2 class="nuttrema-widget__title">{{ $t('label.complete_the_setting_of_your_instance') }}</h2>
      <p class="nuttrema-widget__sub_title">{{ $tc('label.a_few_more_settings', failures) }}</p>

      <ul class="nuttrema-widget__notes">
        <li v-if="!_get(NoticesInstance, 'data.settings_configured')">
          <router-link
             tag="a"
            :to="{ name: 'instance-profile-details' }">
            <div class="nuttrema-widget__notice">
              <div class="notice__icon">
                <nuttrema-iconica-sidebar-link icon="fal fa-globe"></nuttrema-iconica-sidebar-link>
              </div>
              <div class="notice__text">
                <div class="notice__text--title">{{ $t('label.region_and_language') }}</div>
                <div class="notice__text--info">{{ $t('label.region_and_language_set_info') }}</div>
              </div>
              <div class="notice__action">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </router-link>
        </li>

        <li v-if="!_get(NoticesInstance, 'data.all_sources_set')">
          <router-link
             tag="a"
            :to="{ name: 'instance-settings-sources' }">
            <div class="nuttrema-widget__notice">
              <div class="notice__icon">
                <nuttrema-iconica-sidebar-link icon="far fa-cube"></nuttrema-iconica-sidebar-link>
              </div>
              <div class="notice__text">
                <div class="notice__text--title">{{ $t('label.sources') }}</div>
                <div class="notice__text--info">{{ $t('label.all_sources_set_info') }}</div>
              </div>
              <div class="notice__action">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { get } from 'lodash';

import { SCOPES } from 'constants/roles';
import { checkScopesPermition } from 'utils/check-permissions';

import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import AbstractWidget from './abstract-widget';

export default {
  name: 'widget-notices-instance',
  mixins: [
    AbstractWidget,
  ],
  props: {
    NoticesInstance: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaIconicaSidebarLink,
  },
  data: () => ({
    failures: 0,
    showInitNotice: false,
  }),
  methods: {
    getShowNotice() {
      const scopes = get(this.PersonalProfile, 'meta.permissions.scopes', []);

      const settingsConfigured = get(this.NoticesInstance, 'data.settings_configured') ? 0 : 1;
      const instanceSettingsSources = get(this.NoticesInstance, 'data.all_sources_set') ? 0 : 1;

      this.failures = Number(settingsConfigured + instanceSettingsSources);

      return this.failures > 0 && checkScopesPermition(scopes, SCOPES.INSTANCE_OWNER);
    },
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    showNotice() {
      return this.getShowNotice();
    },
  },
  created() {
    this.showInitNotice = this.getShowNotice();
  },
};
</script>

<style lang="scss" scoped>
  @import './abstract-widget';
</style>




// WEBPACK FOOTER //
// src/components/ui/widgets/widget-notices-instance.vue